import * as yup from 'yup';

import { RegexRules } from '../../../../../../../utils';
import { ICheckboxConfig } from '../../../../../../shared/ui/form/checkboxes/Checkboxes.types';
import { IFirstStageValuesCushingV2 } from './FirstStage.types';

export const psychiatricDisordersCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'zaburzenia nastroju',
    name: 'zaburzenia nastroju'
  },
  {
    label: 'psychoza',
    name: 'psychoza',
    size: 3
  },
  {
    label: 'zaburzenia snu',
    name: 'zaburzenia snu'
  },
  {
    label: 'chwiejność emocjonalna',
    name: 'chwiejność emocjonalna'
  },
  {
    label: 'zaburzenia funkcji poznawczych',
    name: 'zaburzenia funkcji poznawczych',
    size: 5
  }
];

export const physicalExaminationsCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'otyłość z centralną redystrybucją tkanki tłuszczowej',
    name: 'otyłość z centralną redystrybucją tkanki tłuszczowej',
    size: 7
  },
  {
    label: 'plethora',
    name: 'plethora',
    size: 2
  },
  {
    label: 'żywoczerwone rozstępy',
    name: 'żywoczerwone rozstępy',
    size: 4
  },
  {
    label: 'obrzęki obwodowe',
    name: 'obrzęki obwodowe',
    size: 3
  },
  {
    label: 'miopatia proksymalna',
    name: 'miopatia proksymalna'
  },
  {
    label: 'hirsutyzm',
    name: 'hirsutyzm',
    size: 2
  },
  {
    label: 'trądzik',
    name: 'trądzik',
    size: 2
  },
  {
    label: 'hiperpigmentacja skóry',
    name: 'hiperpigmentacja skóry'
  }
];
export const thromboembolicComplicationsCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'zatorowość płucna',
    name: 'zatorowość płucna',
    size: 3
  },
  {
    label: 'zakrzepica układu żył głębokich kończyn dolnych',
    name: 'zakrzepica układu żył głębokich kończyn dolnych',
    size: 7
  }
];
export const carbohydrateMetabolismDisordersCheckboxesConfig: ICheckboxConfig[] = [
  {
    label: 'cukrzyca',
    name: 'cukrzyca',
    size: 2
  },
  {
    label: 'nieprawidłowa glikemia na czczo',
    name: 'nieprawidłowa glikemia na czczo',
    size: 5
  },
  {
    label: 'nieprawidłowa tolerancja glukozy',
    name: 'nieprawidłowa tolerancja glukozy',
    size: 5
  }
];

export const symptonsOptions: string[] = [
  'wzrost masy ciała',
  'nadmierny apetyt',
  'łatwe męczenie się',
  'osłabienie mięśni',
  'bóle głowy',
  'łatwe siniaczenie',
  'zaburzenia psychiatryczne'
];

export const complicationsOfHypercortisolismOptions: string[] = [
  'nadciśnienie tętnicze',
  'niewydolność serca',
  'powikłania zakrzepowo-zatorowe',
  'hipokalemia',
  'złamania',
  'zaburzenia gospodarki węglowodanowej',
  'obniżona gęstość mineralna kości',
  'dyslipidemia',
  'kamica moczowa'
];

export const validationFirstStageSchema = yup.object().shape({
  gender: yup.string(),
  weight: yup.string().matches(RegexRules.NUMBER).required(),
  height: yup.string().matches(RegexRules.NUMBER).required(),
  bloodPressure: yup.string().required(),
  heartRate: yup.number().min(1).max(300).required(),
  psychiatricDisorders: yup.array().when('symptoms', {
    is: (value: string[]) => value?.includes('zaburzenia psychiatryczne'),
    then: schema => schema.min(1).required()
  }),
  thromboembolicComplications: yup.array().when('complicationsOfHypercortisolism', {
    is: (value: string[]) => value?.includes('powikłania zakrzepowo-zatorowe'),
    then: schema => schema.min(1).required()
  }),
  descriptionOfFractures: yup.string().when('complicationsOfHypercortisolism', {
    is: (value: string[]) => value?.includes('złamania'),
    then: schema => schema.required()
  }),
  comorbidities: yup.array().of(yup.string().required().trim().min(0, 'Nie może być pustym stringiem')).ensure()
});

export const initialFirstStage: IFirstStageValuesCushingV2 = {
  symptoms: [],
  psychiatricDisorders: [],
  weight: -1,
  height: -1,
  bmi: -1,
  bloodPressure: '',
  heartRate: -1,
  gender: '',
  physicalExaminations: [],
  complicationsOfHypercortisolism: [],
  thromboembolicComplications: [],
  descriptionOfFractures: '',
  carbohydrateMetabolismDisorders: [],
  comorbidities: []
};
